import { useQuery } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../../../_hooks/useClientId';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';
import { OptionType } from '../../../../../CommonComponents/OPL/Select/BaseSelect/types';

export interface BeneficiariesOptionsDTO {
  Id: string;
  Name: string;
}

export interface TransferMethodOptionsDTO {
  value: number;
  label: string;
}

export interface IncludedInEstatePlanOptionsDTO extends OptionType<number> {}

interface OwnerOptionsDTO {
  Name: string;
  FullName: string;
  IsTrust: boolean;
}

export interface EstatePlanningExplanationOptionsDTO {
  BeneficiariesOptions: BeneficiariesOptionsDTO[];
  OwnerOptions: OwnerOptionsDTO[];
  IncludedInEstatePlanOptions: IncludedInEstatePlanOptionsDTO[];
  TransferMethodOptions: TransferMethodOptionsDTO[];
}

const fetchEstatePlanningExplanationOptions = async ({
  clientId,
  fpId,
}): Promise<EstatePlanningExplanationOptionsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/EstatePlanningExplanation/Options', {
      clientId,
      fpId,
    }),
  );
};

export const useEstatePlanningExplanationOptionsQuery = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  return useQuery(
    queryKeys.estatePlanningExplanationOptions(clientId, fpId),

    () => fetchEstatePlanningExplanationOptions({ clientId, fpId }),

    {
      cacheTime: 0,
    },
  );
};
